module.exports = __webpack_public_path__ + "img/google.4aa6c18c.png";